/**
 * DevExtreme (esm/__internal/core/license/types.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var TokenKind;
!function (TokenKind) {
  TokenKind.corrupted = "corrupted";
  TokenKind.verified = "verified";
  TokenKind.internal = "internal";
}(TokenKind || (TokenKind = {}));